import { render, staticRenderFns } from "./RightArrowIcon.vue?vue&type=template&id=ede18604&scoped=true&"
var script = {}
import style0 from "./RightArrowIcon.vue?vue&type=style&index=0&id=ede18604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede18604",
  null
  
)

export default component.exports